import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const Container = ({ children }: { children: React.ReactNode }) => {
  return <div css={container}>{children}</div>;
};

const container = css`
  padding: ${theme.spacing(2)};
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.neutral20};
`;
